import React from "react";
// Component
import MainTable from '../../Components/Tables/Main/MainTable'
import ButtonSwitchBetweenTables from '../../Components/Buttons/ButtonSwitchBetweenTables'
// Hook
import { useVehicles } from "../../Hooks/useVehicles";
// Library
import RemoveCircle from '@material-ui/icons/RemoveCircle';
import NotificationImportant from '@material-ui/icons/NotificationImportant';
import { useHistory } from "react-router-dom";
// Constants
import { columns, actions, requiredFields, deleteText } from "./VehicleReusableConstants"

const Vehicles = () => {
    const [vehiclesData, addVehicle, updateVehicle, deleteVehicle, deregisterVehicle] = useVehicles(true);

    const history = useHistory();

    const navigateToInactiveVehicles = () => history.push('/vehicles/inactive')
    const navigateToVehicleAlerts = (vehicleId) => history.push(`/vehicle/${vehicleId}/alerts`)

    const allActions = [{
        icon: RemoveCircle,
        tooltip: "Desactivar",
        onClick: async (event, rowData) => {
            await deregisterVehicle(rowData.id)
            navigateToInactiveVehicles()
        },
    }, ...(actions(history))];

    allActions.splice(3, 0, 
        rowData => ({
        icon: () => <NotificationImportant style={{ color: rowData.hasActiveAlerts ? "red" : "black" }} />,
        tooltip: "Alertas",
        onClick: (event, vehicle) => {
            navigateToVehicleAlerts(vehicle.id)
        },
    }))

    return (
        <div>
            <ButtonSwitchBetweenTables text={'Ver vehículos inactivos'} onClick={navigateToInactiveVehicles} />
            <MainTable
                {...{ deleteText, requiredFields, columns }}
                title="Vehículos activos"
                actions={allActions}
                data={vehiclesData}
                onRowAdd={addVehicle}
                onRowUpdate={updateVehicle}
                onRowDelete={deleteVehicle}
            />
        </div>)
}

export default Vehicles


// WEBPACK FOOTER //
// ./src/Containers/Vehicles/ActiveVehicles.js